import MidiAction from './MidiAction.js';
import {RESOLUTION} from 'constants/midi-actions.js';
import Resolution from 'engine/Resolution.js';

class ResolutionAction extends MidiAction {
    constructor(sequencerEngine, resolution) {
        super(RESOLUTION);

        this.sequencerEngine = sequencerEngine;
        this.resolution = resolution;
    }

    execute(val) {
        let resolutionOptions = RESOLUTION_OPTIONS
            .filter(r => r.isTriplet === this.resolution.isTriplet);
        
        let x = 127 / (resolutionOptions.length);
        let index = Math.floor(val / x);
        if (index >= resolutionOptions.length) {
            index = resolutionOptions.length - 1;
        }
        let resolution = resolutionOptions[index];
        if (this.sequencerEngine.resolution.equals(resolution)) {
            return;
        }
        this.sequencerEngine.resolution = resolution;
    }
}

const RESOLUTION_OPTIONS = [
    new Resolution(4, false), 
    new Resolution(4, true), 
    new Resolution(8, false), 
    new Resolution(8, true), 
    new Resolution(16, false), 
    new Resolution(16, true), 
    new Resolution(32, false), 
    new Resolution(32, true) 
];

export default ResolutionAction;
